import { render, staticRenderFns } from "./app-menu.vue?vue&type=template&id=21474aee&scoped=true&"
import script from "./app-menu.vue?vue&type=script&lang=js&"
export * from "./app-menu.vue?vue&type=script&lang=js&"
import style0 from "./app-menu.vue?vue&type=style&index=0&id=21474aee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21474aee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21474aee')) {
      api.createRecord('21474aee', component.options)
    } else {
      api.reload('21474aee', component.options)
    }
    module.hot.accept("./app-menu.vue?vue&type=template&id=21474aee&scoped=true&", function () {
      api.rerender('21474aee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-menu/app-menu.vue"
export default component.exports